export const pickupTableColumnStyle = {
  courier: { width: '120px' },
  dateTime: { width: '176px' },
  details: { width: '123px', 'text-align': 'center' },
  pickupId: { width: '147px', 'text-align': 'center' },
  pickupAddress: { width: '150px' },
  requestStatus: { width: '146px' },
  actions: { width: '197px' },
};
